import type { CameraMode, CameraModeOptions, FollowDirection } from '@rcs/renderer';

/** 画面で選ぶ視点。全体俯瞰、追従（後方・前方・側方）、乗客視点。 */
export type ViewKind = 'overview' | 'follow-behind' | 'follow-front' | 'follow-side' | 'passenger';

/** 視点の一覧（表示順）。 */
export const VIEW_KINDS: readonly ViewKind[] = [
  'overview',
  'follow-behind',
  'follow-front',
  'follow-side',
  'passenger',
];

/** 既定の視点。 */
export const DEFAULT_VIEW: ViewKind = 'overview';

const FOLLOW_OF: Readonly<Partial<Record<ViewKind, FollowDirection>>> = {
  'follow-behind': 'behind',
  'follow-front': 'front',
  'follow-side': 'side',
};

/** 視点を、レンダラーのカメラの種類とオプションに変換する。 */
export function viewToCamera(view: ViewKind): {
  readonly mode: CameraMode;
  readonly options: CameraModeOptions;
} {
  if (view === 'passenger') return { mode: 'passenger', options: {} };
  const follow = FOLLOW_OF[view];
  return follow === undefined
    ? { mode: 'overview', options: {} }
    : { mode: 'follow', options: { follow } };
}
